import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import FeaturedVideos from "../components/FeaturedVideos";
import HowItWorks from "../components/HowItWorks";
import PlansAndPricing from "../components/PlansAndPricing";
import Testimonials from "../components/Testimonials";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

const Home = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow">
        <Hero />
        <FeaturedVideos />
        <HowItWorks />
        <PlansAndPricing />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
